import {
  Language,
  LanguageStoreAction,
  LanguageStoreKind,
  LanguageStoreType,
} from './languageStore.types';

export const INITIAL_LANGUAGE = {
  language: Language.DE,
  firstLanguageChangeDone: false,
};

const labelsStore = (
  state: LanguageStoreType,
  action: LanguageStoreAction
): LanguageStoreType => {
  switch (action.type) {
    case LanguageStoreKind.INITIAL: {
      return {
        ...state,
        language: action.payload,
      };
    }
    case LanguageStoreKind.UPDATE_FIRST_CHANGE_DONE: {
      return {
        ...state,
        firstLanguageChangeDone: action.payload,
      };
    }
    default:
      throw new Error();
  }
};

export default labelsStore;
